export const DISPERSEABI = {
    rinkebyTestnet: "0xdbcb48eFD02f2a337CA02d05CBB59c3BDe814EB3",
    reiMainnet: "0x5F7a0F7BDbD04d92db9E212f557716605C58c6F9",
    reiTestnet: "0x9fb67232Ace5FBecE68f0c4d07F6d111ff9F3Bac",
};